import { FairFareQueryParams, getFairFareQueryParams } from 'types/interfaces/shared';
import { getBaseURL, getClient } from '../BLL/clients/HttpClient';
import { ApiEndPoint } from '../BLL/Enums/ApiEndPoint';
import { ProviderLocation } from '../components/ClaimsLocationMap/types';

export interface MonthlyProviderTypeData {
  month: string;
  er: number;
  urgentCare: number;
}

export interface SteerageStatsData {
  total: number;
  success: number;
  failed: number;
  providerTypes: {
    er: number;
    urgentCare: number;
    hospital: number;
    dental: number;
    other: number;
  };
  monthlyProviderTypes: MonthlyProviderTypeData[];
  providerLocations: ProviderLocation[];
}

export interface SteerageData {
  id: number;
  createdAt: Date;
  caseId: number | null;
  providerType: string;
  policyNumber: string | null;
  // vobStatus: boolean | null;
  providerName: string;
  providerAddress: string;
  // projectedMedicareMultiplier: number;
  steeredBy: string;
  admissionStatus: string;
  /** The network the provider was chosen from; null when out of network. */
  networkName?: string | null;
  /** That network's logo (an https URL or a data URI); null when it has none. */
  networkLogoUrl?: string | null;
}

export interface SteeragePagination {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

export interface SteerageResponse {
  steerages: SteerageData[];
  pagination: SteeragePagination;
}

export const getAllSteerages = async (
  query: FairFareQueryParams,
  carrierId?: number
): Promise<SteerageResponse> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  const params = getFairFareQueryParams(query);
  if (carrierId) {
    (params as any).carrierId = carrierId;
  }

  const { data } = await client.get<SteerageResponse>('v1/steerage', {
    params,
  });

  // Format dates
  const formattedData = {
    ...data,
    steerages: data.steerages.map((steerage) => ({
      id: steerage.id,
      caseId: steerage.caseId,
      providerType: steerage.providerType,
      policyNumber: steerage.policyNumber,
      // vobStatus: steerage.vobStatus,
      providerName: steerage.providerName,
      providerAddress: steerage.providerAddress,
      // projectedMedicareMultiplier: steerage.projectedMedicareMultiplier,
      steeredBy: steerage.steeredBy,
      admissionStatus: steerage.admissionStatus,
      networkName: steerage.networkName ?? null,
      networkLogoUrl: steerage.networkLogoUrl ?? null,
      createdAt: new Date(steerage.createdAt),
    })),
  };

  return formattedData;
};

export const getSteerageStats = async (
  carrierId?: number
): Promise<SteerageStatsData> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  const params: any = {};
  if (carrierId) {
    params.carrierId = carrierId;
  }

  const { data } = await client.get<SteerageStatsData>('v1/steerage/stats', {
    params,
  });

  return data;
};
